import { render, staticRenderFns } from "./kiosk_home.vue?vue&type=template&id=16446486&scoped=true"
import script from "./kiosk_home.vue?vue&type=script&lang=js"
export * from "./kiosk_home.vue?vue&type=script&lang=js"
import style0 from "./kiosk_home.vue?vue&type=style&index=0&id=16446486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16446486",
  null
  
)

export default component.exports